<script>
import FormRadio from "@/components/molecules/form-radio";
import Form from "@/components/molecules/form";
import FormGroup from "@/components/molecules/form-group";
import Alert from "@/components/molecules/alert";
import Icon from "@/components/atoms/icon";
import PaymentMethodCard from "./cards";
import DeleteCardForm from "@/containers/payment-card-list/delete-card-form";
import Popin from "@/containers/popin-adaptive";

export default {
  name: "PaymentMethodCardsRegistered",
  components: {
    Form,
    FormGroup,
    FormRadio,
    Alert,
    PaymentMethodCard,
    Icon,
    DeleteCardForm,
    Popin
  },

  props: {
    shopAlert: {
      type: Boolean,
      required: false,
      default: false
    },
    aliasPaiement: {
      type: Array,
      required: false,
      default: () => []
    },
    aliasMaxParMagasin: {
      type: Number,
      required: false,
      default: 0
    },
    magasinName: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ["updateAliasPaiement"],
  data() {
    return {
      aliasPaiementSelected: undefined,
      aliasToDelete: null,
      localAliasPaiement: this.aliasPaiement
    };
  },
  methods: {
    updateAliasPaiement(idAliasPaiement) {
      this.$emit("updateAliasPaiement", idAliasPaiement);
    },
    deleteCard(aliasPaiement) {
      this.aliasToDelete = aliasPaiement;
      this.$refs.supprimerCarte.show();
    },
    deleteValid() {
      this.$refs.supprimerCarte.hide();
      this.localAliasPaiement = this.aliasPaiement.filter((alias) => {
        return alias !== this.aliasToDelete;
      });
    }
  }
};
</script>

<template>
  <div>
    <div class="c-payment-method-cards-registered__title c-payment-method-cards-registered__title--dotted u-mt-md u-mb-md">
      <p class="u-mr-xs u-mr-none@sm">
        <template v-if="shopAlert">
          Votre carte de paiement
        </template>
        <template v-else>
          Sélectionnez votre carte de paiement
        </template>
      </p>
    </div>
    <div class="u-mx-lg u-mx-none@md">
      <div v-if="shopAlert">
        <div class="u-flex u-flex-column@sm u-flex-align-center@sm u-radius-md u-bgcolor-bg u-py-sm u-px-md u-mt-sm">
          <Icon
            name="info-circle-outline"
            variant="primary"
            size="sm"
            class="u-flex-shrink-none u-mr-xs u-mr-none@sm u-mb-sm@sm"
          />
          <p>
            <span class="u-font-700">
              Les cartes bancaires enregistrées dans votre compte sont associées à un autre magasin.
            </span>
            <br>
            Si vous le souhaitez, vous pourrez enregistrer votre carte pour le magasin <span class="u-font-700">{{ magasinName }}</span> à l’étape suivante.
          </p>
        </div>
      </div>
      <Form v-else>
        <div>
          <PaymentMethodCard
            v-for="alias in localAliasPaiement"
            :key="alias.id"
            v-model="aliasPaiementSelected"
            :value="alias.attributes.id_alias"
            :alias="alias"
            @updateAliasPaiement="updateAliasPaiement"
            @deleteCard="deleteCard"
          />
          <Alert
            v-if="localAliasPaiement.length >= aliasMaxParMagasin"
            variant="white"
            has-icon
            icon-name="info-circle-outline"
            icon-color="primary"
            icon-size="sm"
            icon-position="left-top"
            class="u-my-xs"
          >
            <p class="u-font-14 u-color-grey-10">
              Le nombre de carte enregistrée est limité à {{ aliasMaxParMagasin }}. Pour ajouter une nouvelle carte, vous devez d’abord supprimer une carte existante. Vous pouvez également utiliser une autre carte sans l’enregistrer
            </p>
          </Alert>

          <FormGroup
            size="full"
            class="u-mt-sm"
          >
            <FormRadio
              v-model="aliasPaiementSelected"
              name="card"
              :value="null"
              block
              @change="updateAliasPaiement"
            >
              J'utilise une autre carte
            </FormRadio>
          </FormGroup>
        </div>
      </Form>
    </div>
    <Popin ref="supprimerCarte">
      <DeleteCardForm
        :carte="aliasToDelete"
        @deleteValid="deleteValid()"
      />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/payment-method-cards-registered.scss";
</style>
